module.exports = "<p ng-repeat=\"guestListEntry in $ctrl.data\">\n    <strong>{{guestListEntry.expectedArrival | date:'medium'}}</strong><br/>\n    <span ng-if=\"!guestListEntry.guest.isBusiness\">{{guestListEntry.guest.firstName}} {{guestListEntry.guest.middleName}} {{guestListEntry.guest.lastName}}</span>\n    <span ng-if=\"guestListEntry.guest.isBusiness\">{{guestListEntry.guest.business}} (Business)</span>\n</p>\n<p ng-if=\"!$ctrl.data || $ctrl.data.length == 0\">\n    No guest expected today\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/piper-expected-today-widget/piper-expected-today-widget.component.html
// module id = 549
// module chunks = 0